import { render, staticRenderFns } from "./CreateImprovement.vue?vue&type=template&id=2014103c&scoped=true"
import script from "./CreateImprovement.vue?vue&type=script&lang=js"
export * from "./CreateImprovement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2014103c",
  null
  
)

export default component.exports